export const optionsArea = [
    {id: 1, name: "France"},
    {id: 2, name: "International"}
]
